import ProductServices from "@services/ProductServices";
import React, { useEffect, useState } from "react";
import { BsArrowDownShort, BsArrowUpShort } from "react-icons/bs";

export default function SkuToTitle({ coupon }) {
  const [titles, setTitles] = useState([]);
  const [more, setMore] = useState(false);
  useEffect(() => {
    const couponList = JSON.parse(coupon.sku);
    if (couponList.length > 0) {
      ProductServices.getProducttitleFromSku(couponList)
        .then((res) => setTitles(res.titles))
        .catch((err) => console.log(err.response.data.message));
    }
  }, [coupon.sku]);

  return (
    <div>
      {coupon.elligibleType.localeCompare("sku") === 0 && (
        <p className="text-xs leading-4 text-gray-500 mt-2">
          * This coupon apply when your order item is under elligible sku{" "}
          {titles.map((sku, sindex) => {
            if (!more) {
              if (sindex < 1) {
                return (
                  <span key={sindex} className="font-bold">
                    {" "}
                    {sku} <br />
                  </span>
                );
              } else "";
            } else {
              return (
                <span key={sindex} className="font-bold">
                  {" "}
                  {sku} <br />
                </span>
              );
            }
          })}{" "}
          <button
            onClick={() => setMore(!more)}
            className=" bg-gray-200 hover:bg-gray-300 duration-300 rounded-sm px-1 flex items-center"
          >
            {!more ? "See More" : "See Less"}
            {!more ? <BsArrowDownShort /> : <BsArrowUpShort />}
            {/* see more <BsArrowDownShort /> */}
          </button>
        </p>
      )}
    </div>
  );
}
